export { DetachedAppPage } from './DetachedAppPage'
